import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '岗位角色',
    type: 'OU_OR',
}
